import React, { Component } from "react";
import axios from "axios";
import moment from "moment";
import _ from "lodash";

import {
  Table,
  Tooltip,
  Icon,
  Divider,
  Button,
  Modal,
  Pagination,
  Row,
  Col,
  Radio,
  Input,
} from "antd";

import AddPatientModal from "./AddPatientModal";

const { Column } = Table;
const { confirm } = Modal;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const { Search } = Input;

class FetchAllUsers extends Component {
  state = {
    loading: false,
    data: [],
    userLength: "",
    searchValue: "",
    visiblePatientModal: false,
    put: false,
    id: "",
    pageNo: 1,
    size: 10,
    editDetail: {},
    selectSearchOption: "name",
    hospital:
      window.location.port !== process.env.REACT_APP_HOSPITAL_PORT &&
      window.location.hostname !== process.env.REACT_APP_HOSPITAL_URL,
  };

  componentDidMount = () => {
    this.getUser();
    this.getUserCount();
  };

  getUser = () => {
    const { pageNo, size } = this.state;
    this.setState({ loading: true });
    axios({
      method: "get",
      url: `/users.json?page=${pageNo}&page_size=${size}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    })
      .then((response) => {
        // console.log(response.data);
        this.setState({ data: response.data });
        this.setState({ loading: false });
      })
      .catch((error) => {
        alert(`${error}: ${error.code}`);
      });
  };

  getUserCount = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url: "/users/users_count",
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      this.setState({
        userLength: response.data.users_count,
        loading: false,
      });
    });
  };

  onShowSizeChange = (current, pageSize) => {
    console.log(current, pageSize);
    this.setState({
      loading: true,
      pageNo: current,
      size: pageSize,
    });
    axios({
      method: "get",
      url: `/users.json?page=${current}&page_size=${pageSize}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      this.setState({
        data: response.data,
        loading: false,
      });
    });
  };

  onChange = (current, pageSize) => {
    this.setState(
      {
        loading: true,
        searchValue: "",
        pageNo: current,
        size: pageSize,
      },
      () => {
        axios({
          method: "get",
          url: `/users.json?page=${current}&page_size=${pageSize}`,
          headers: {
            Authorization: sessionStorage.getItem("jwtToken"),
          },
        }).then((response) => {
          this.setState({
            data: response.data,
            loading: false,
          });
        });
      }
    );
  };

  // Searching starts here
  onSearchChange = (event) => {
    this.setState({
      selectSearchOption: event.target.value,
    });
  };

  onSearchSubmit = (value) => {
    const { selectSearchOption } = this.state;
    this.setState({ fetching: true });
    if (selectSearchOption === "name") {
      axios({
        method: "get",
        url: `users/search_by_name.json?name=${value}`,
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
      }).then((response) => {
        this.setState({
          data: response.data,
          fetching: false,
        });
      });
    } else if (selectSearchOption === "mobile") {
      axios({
        method: "get",
        url: `users/search_by_mobile.json?mobile_number=${value}`,
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
      }).then((response) => {
        this.setState({
          data: response.data,
          fetching: false,
        });
      });
    }
  };
  // searching ends here

  changeSubmitValue = (event) => {
    if (event.target.value === "") {
      this.getUser();
    }
    this.setState({ searchValue: event.target.value });
  };

  saveFormRefPatient = (formRef) => {
    this.formRefPatient = formRef;
  };

  showModal = () => {
    this.setState({ visiblePatientModal: true });
  };

  handleCancel = () => {
    this.setState({
      visiblePatientModal: false,
      put: false,
      id: "",
      editDetail: {},
    });
  };

  handleCreate = () => {
    const { put, id } = this.state;
    const { form } = this.formRefPatient.props;
    form.validateFields((err, values) => {
      if (err) {
        console.log(err);
        return;
      }

      if (values.dob !== undefined) {
        values.dob = moment(values.dob).format("YYYY-MM-DD");
      } else {
        values.dob = "";
      }

      if (values.last_name === undefined) {
        values.last_name = "";
      }

      // console.log(values, 'Submitted');
      // values.user_type = 'patient';

      values.address = {
        line_1: values.line_1,
        line_2: values.line_2,
        city: values.city,
        state: values.state,
        pin_code: values.pin_code,
        country: values.country,
      };

      delete values.line_1;
      delete values.line_2;
      delete values.city;
      delete values.state;
      delete values.pin_code;
      delete values.country;

      if (put) {
        console.log(values);
        axios({
          method: "put",
          url: `/users/${id}.json`,
          headers: {
            Authorization: sessionStorage.getItem("jwtToken"),
          },
          data: { user: values },
        }).then(() => {
          // console.log(response.data);
          form.resetFields();
          this.handleCancel();
          window.location.reload();
        });
      } else {
        axios({
          method: "post",
          url: "/users/create_patient",
          headers: {
            Authorization: sessionStorage.getItem("jwtToken"),
          },
          data: { user: values },
        }).then(() => {
          // console.log(response.data);
          form.resetFields();
          this.handleCancel();
          window.location.reload();
        });
      }
    });
  };

  handleLabelPrint = (record) => {
    let name = record.first_name + " " + record.last_name;
    let age = record.age;
    let gender = record.sex;
    let address =
      record.addresses.length >= 1
        ? record.addresses[0].city
          ? record.addresses[0].city
          : ""
        : "";
    let uid = record.id;
    window.open(
      `https://label.caredose.com/result_patient_label?name=${name}&age=${age}&gender=${gender}&add=${address}&uid=${uid}`
    );
  };
  showModalEdit = (id) => {
    const { data } = this.state;
    const detail = data.filter((user) => user.id === id);
    this.setState({
      visiblePatientModal: true,
      put: true,
      id,
      editDetail: detail[0],
    });
  };

  showDeleteConfirm = (id) => {
    confirm({
      title: "Are you sure?",
      content:
        "This user will be deleted from the database & can not be recovered.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: () => {
        axios({
          method: "delete",
          url: `/users/${id}.json`,
          headers: {
            Authorization: sessionStorage.getItem("jwtToken"),
          },
        })
          .then(() => {
            // console.log(response.data);
            window.location.reload();
          })
          .catch((error) => alert(error));
      },
      onCancel: () => {
        console.log("Cancel");
      },
    });
  };

  render() {
    const { history } = this.props;
    const {
      selectSearchOption,
      searchValue,
      data,
      loading,
      userLength,
      visiblePatientModal,
      editDetail,
    } = this.state;
    // console.log(data);

    return (
      <div>
        <h2 style={{ textAlign: "center" }}>All Users</h2>
        <hr width="100px" />

        <Row type="flex" justify="center">
          <Col>
            <RadioGroup
              onChange={this.onSearchChange}
              value={selectSearchOption}
            >
              <RadioButton value="name">Name</RadioButton>
              <RadioButton value="mobile">Mobile</RadioButton>
            </RadioGroup>
          </Col>

          <Col style={{ marginLeft: "10px" }}>
            <Search
              className="m-auto"
              enterButton
              value={searchValue}
              onChange={(event) => this.changeSubmitValue(event)}
              placeholder="Name/Mobile"
              onSearch={(value) => this.onSearchSubmit(value)}
              style={{ width: 300 }}
            />
          </Col>
        </Row>

        <Table
          style={{ marginTop: "5%" }}
          dataSource={data}
          pagination={false}
          loading={loading}
          bordered
          scroll={{ x: 1600 }}
          size="small"
          rowKey="id"
        >
          <Column
            title="Id"
            dataIndex="id"
            width={100}
            fixed="left"
            align="center"
          // key="id"
          />

          <Column
            title="Name"
            width={200}
            fixed="left"
            // key="first_name"
            render={(record) => (
              <span
                onClick={() => history.push(`/users/${record.id}`)}
                role="button"
              >
                <a>
                  {record.last_name == null
                    ? `${record.first_name}`
                    : `${record.first_name} ${record.last_name}`}
                </a>
              </span>
            )}
          />

          <Column
            title="Mobile Number"
            dataIndex="mobile_number"
          // key="mobile_number"
          />

          <Column
            title="# Orders"
            dataIndex="num_orders"
          // key="num_orders"
          />

          <Column
            title="Last Order"
            dataIndex="last_orders"
          // key="num_orders"
          />

          <Column
            title="Address"
            // key="id"
            render={(record) => {
              const { addresses } = record;

              if (addresses.length === 0) {
                return "";
              }
              const address = addresses[0];
              return (
                <span>
                  <p>{address.line_1}</p>
                  <p>
                    {address.line_2}, {address.city}
                  </p>
                  <p>
                    {address.state}, {address.pin_code}
                  </p>
                </span>
              );
            }}
          />

          <Column
            title="Action"
            // key="id"
            render={(record) => (
              <span>
                <Tooltip placement="top" title="View Orders">
                  <span
                    onClick={() => history.push(`/users/${record.id}`)}
                    role="button"
                  >
                    <a>
                      <Icon type="file-text" />
                    </a>
                  </span>
                </Tooltip>

                <Divider type="vertical" />

                <Tooltip placement="top" title="Edit User">
                  <span>
                    <a
                      onClick={() => this.showModalEdit(record.id)}
                      role="button"
                    >
                      <Icon type="edit" />
                    </a>
                  </span>
                </Tooltip>

                <Divider type="vertical" />
                {!this.state.hospital && (
                  <Tooltip placement="top" title="Print Label">
                    <span
                      onClick={() => this.handleLabelPrint(record)}
                      role="button"
                    >
                      <a>
                        <Icon style={{ color: "blue" }} type="printer" />
                      </a>
                    </span>
                  </Tooltip>
                )}
                {this.state.hospital && (
                  <Tooltip placement="top" title="Delete User">
                    <span
                      onClick={() => this.showDeleteConfirm(record.id)}
                      role="button"
                    >
                      <a>
                        <Icon style={{ color: "red" }} type="delete" />
                      </a>
                    </span>
                  </Tooltip>
                )}
              </span>
            )}
          />
        </Table>

        <br />

        {!searchValue ? (
          <Pagination
            style={{ float: "right" }}
            showSizeChanger
            onShowSizeChange={this.onShowSizeChange}
            defaultCurrent={1}
            total={userLength}
            onChange={_.debounce(this.onChange, 300)}
          />
        ) : null}

        <div>
          <Button type="primary" onClick={this.showModal}>
            Add New User
          </Button>

          {visiblePatientModal ? (
            <AddPatientModal
              visible={visiblePatientModal}
              data={editDetail}
              wrappedComponentRef={this.saveFormRefPatient}
              onCancel={this.handleCancel}
              onCreate={this.handleCreate}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

export default FetchAllUsers;



// WEBPACK FOOTER //
// ./src/component/Users/FetchAllUsers.js